import { useUrlGenerator } from '@folklore/routes';
import { useParams } from 'wouter';

import usePage from '../../hooks/usePage';

import Metadata from './Metadata';
import NotfoundMetadata from './NotfoundMetadata';

function PageMetadata() {
    const { slug: slugParam = null } = useParams<{ slug?: string }>();
    const { page = null } = usePage(slugParam);
    const url = useUrlGenerator();

    if (page === null) {
        return <NotfoundMetadata />;
    }

    const { title, slug, image } = page;

    return (
        <Metadata
            title={title}
            image={image}
            url={url('page', {
                slug,
            })}
            pageType="page"
        />
    );
}

export default PageMetadata;
